import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Terms = () => {

  const termsData = [
    {
      id: 1,
      title: "Introduction",
      description:
        "These Terms and Conditions outline the rules and regulations for using our website and services. By accessing or making a purchase on our site, you agree to comply with these terms. If you do not agree, please refrain from using the site.",
      is_active: 1,
    },
 
    {
      id: 3,
      title: "Account Responsibility",
      description:
        "If you create an account with us, you are responsible for maintaining the confidentiality of your login details.\nYou agree to:\n\n• Keep your password secure.\n• Notify us immediately of unauthorized access.\n• Provide accurate and updated information.",
      is_active: 1,
    },
    {
      id: 4,
      title: "Product Information",
      description:
        "We strive to provide accurate product images, descriptions, and pricing. However:\n\n• Colors may vary due to screen settings.\n• Product availability may change.\n• Pricing errors may occur, and we reserve the right to correct them.",
      is_active: 1,
    },
    {
      id: 5,
      title: "Pricing & Payments",
      description:
        "All prices listed are in INR unless specified otherwise.\nWe accept secure digital payments through trusted payment gateways.\n\nWe reserve the right to:\n• Modify prices at any time.\n• Cancel orders due to pricing errors or fraud suspicion.",
      is_active: 1,
    },
    {
      id: 6,
      title: "Order Confirmation & Cancellation",
      description:
        "Orders may be cancelled if:\n\n• The product is out of stock.\n• The payment fails.\n• Incorrect shipping details are provided.\n• There is suspected fraudulent activity.\n\nYou may request cancellation before the order is shipped.",
      is_active: 1,
    },
    {
      id: 7,
      title: "Shipping & Delivery",
      description:
        "Shipping timelines are estimates and may vary due to:\n\n• Location\n• Courier availability\n• Weather conditions\n• Public holidays\n\nDelays are possible, and we appreciate your understanding.",
      is_active: 1,
    },
   
    {
      id: 9,
      title: "Intellectual Property",
      description:
        "All content on this website including text, images, designs, logos, and graphics is owned by us or our partners.\nYou may not reuse, copy, or distribute our content without permission.",
      is_active: 1,
    },
    {
      id: 10,
      title: "Prohibited Activities",
      description:
        "You agree not to:\n\n• Misuse the website for fraudulent activities.\n• Upload harmful files or viruses.\n• Attempt unauthorized access to servers.\n• Disrupt the website’s functionality.\n• Use automated tools for scraping or data extraction.",
      is_active: 1,
    },
    {
      id: 11,
      title: "Limitation of Liability",
      description:
        "We are not responsible for damages arising from:\n\n• Improper product usage.\n• Third-party courier delays.\n• Website downtime or technical issues.\n• Unauthorized account access due to weak passwords.",
      is_active: 1,
    },
    {
      id: 12,
      title: "Changes to These Terms",
      description:
        "We may update or modify these Terms & Conditions at any time. Changes are effective when posted on this page. Continued use of the website signifies your acceptance of the updated terms.",
      is_active: 1,
    },
   
  ];

  return (
    <>
      <div className="py-5 bg-white">
        <Container>
          <Row>
            <Col md={8}>
              {/* <h2 className="mb-4">Terms & Conditions</h2> */}

              {termsData.map((section) => (
                <div key={section.id} className="mb-4 border-bottom">
                  
                  {/* Header */}
                  <div className="p-3">
                    <h5 className="mb-2 text-dark fw-bold">{section.title}</h5>

                    {/* {section.is_active === 1 && (
                      <span className="text-success small fw-bold">● Active</span>
                    )} */}
                  </div>

                  {/* Body */}
                  <div className="p-3 bg-white border-top">
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "18px",
                        color: "#313131FF",
                        whiteSpace: "pre-line",
                      }}
                    >
                      {section.description}
                    </p>
                  </div>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </div>
      <hr />
    </>
  );
};

export default Terms;
